import SchemaForm from './SchemaForm.vue'
import SchemaFormItem from './SchemaFormItem.vue'
import './style.less'

const useComponent = comps => {
  comps.forEach(comp => {
    SchemaFormItem.components[`schema-form__${comp.name}`] = comp.component
  })
}

export default {
  useComponent,
  component: SchemaForm
}
